import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["modal", "video", "title"];

  connect() {
    $(this.modalTarget).on('hidden.bs.modal', () => {
      this.pauseAndResetVideo();
    });
  }

  disconnect() {
    $(this.modalTarget).off('hidden.bs.modal');
  }

  open(event) {
    event.preventDefault();
    
    const link = event.currentTarget;
    const videoSrc = link.dataset.videoSrc;
    const videoTitle = link.dataset.videoTitle;
    
    // Set video source and title
    this.videoTarget.src = videoSrc;
    this.titleTarget.textContent = videoTitle;
    
    // Show modal
    $(this.modalTarget).modal('show');
  }

  close() {
    $(this.modalTarget).modal('hide');
  }

  pauseAndResetVideo() {
    if (this.hasVideoTarget) {
      this.videoTarget.pause();
      this.videoTarget.currentTime = 0;
      this.videoTarget.src = '';
    }
  }
}